'use strict';

var React = require('react');
var useMatchDevice = require('../../hooks/useMatchDevice.js');
require('imask');
var useRefAndForward = require('../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var component$1 = require('../Divider/component.js');
var index = require('../Flex/index.js');
var component = require('../Portal/component.js');
var styles = require('./styles.js');
var useMaxBodyHeight = require('./useMaxBodyHeight.js');
var usePositionTop = require('./usePositionTop.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const ModalDialog = React.forwardRef(({ isOpened, onClose, header, banner, body, footer, size, fullWidth = false, ...props }, ref) => {
    const isMobile = useMatchDevice.useMatchDevice('mobile');
    const dialogRef = useRefAndForward.useRefAndForward(null, ref);
    const headerRef = React.useRef(null);
    const footerRef = React.useRef(null);
    const hasDividerBetweenHeaderAndBody = header && !isMobile;
    const hasDividerBetweenFooterAndBody = footer && !isMobile;
    const maxBodySectionHeight = useMaxBodyHeight.useMaxBodyHeight({ headerRef, footerRef, isOpened });
    const positionTop = usePositionTop.usePositionTop({ dialogRef, isOpened });
    return (React__default.default.createElement(component.Portal, null,
        React__default.default.createElement("div", null,
            isOpened && React__default.default.createElement(styles.Styled.Backdrop, { "aria-label": "backdrop", onClick: () => onClose() }),
            React__default.default.createElement(styles.Styled.Dialog, { ...props, role: "dialog", "aria-hidden": !isOpened, "aria-modal": true, size: size, fullWidth: fullWidth, isOpened: isOpened, positionTop: positionTop, ref: dialogRef },
                header && (React__default.default.createElement(styles.Styled.Section, { ref: headerRef },
                    React__default.default.createElement(styles.Styled.SectionItem, null, header))),
                hasDividerBetweenHeaderAndBody && React__default.default.createElement(component$1.Divider, null),
                React__default.default.createElement(styles.Styled.Section, { maxHeight: maxBodySectionHeight ?? undefined },
                    React__default.default.createElement(index.Flex.Column, { space: isMobile ? 's' : 'm' },
                        banner && React__default.default.createElement(styles.Styled.SectionItem, null, banner),
                        React__default.default.createElement(styles.Styled.SectionItem, null, body))),
                hasDividerBetweenFooterAndBody && React__default.default.createElement(component$1.Divider, null),
                footer && (React__default.default.createElement(styles.Styled.Section, { ref: footerRef },
                    React__default.default.createElement(styles.Styled.SectionItem, null, footer)))))));
});
ModalDialog.displayName = 'Modal.Dialog';

exports.ModalDialog = ModalDialog;
//# sourceMappingURL=Dialog.js.map
